import { CircleCheck, CircleDashed, CircleX, Clock3, LoaderCircle, OctagonPause, TriangleAlert } from 'lucide-react'
import { titleCase } from '../lib/format'

const statusMap: Record<string, { tone: string; icon: typeof CircleCheck }> = {
  ready: { tone: 'success', icon: CircleCheck },
  completed: { tone: 'success', icon: CircleCheck },
  running: { tone: 'info', icon: LoaderCircle },
  provisioning: { tone: 'info', icon: LoaderCircle },
  queued: { tone: 'neutral', icon: Clock3 },
  pending: { tone: 'neutral', icon: CircleDashed },
  not_started: { tone: 'neutral', icon: CircleDashed },
  partial: { tone: 'warning', icon: TriangleAlert },
  retrying: { tone: 'warning', icon: LoaderCircle },
  stopping: { tone: 'warning', icon: LoaderCircle },
  stopped: { tone: 'neutral', icon: OctagonPause },
  failed: { tone: 'danger', icon: CircleX },
  blocked: { tone: 'danger', icon: CircleX },
  ignored: { tone: 'neutral', icon: CircleDashed },
  // An automation event that was deliberately not acted on - the assistant's own
  // change, an unrelated transition - which is a normal outcome, not a problem.
  skipped: { tone: 'neutral', icon: CircleDashed },
}

const SPINNING_STATUSES = ['running', 'provisioning', 'retrying', 'stopping']

export function StatusBadge({ status, pulse = false }: { status: string; pulse?: boolean }) {
  const normalized = status.toLowerCase()
  const item = statusMap[normalized] ?? statusMap.not_started!
  const Icon = item.icon
  return (
    <span className={`status-badge status-badge--${item.tone}`}>
      <Icon size={13} className={pulse || SPINNING_STATUSES.includes(normalized) ? 'spin' : ''} aria-hidden="true" />
      {titleCase(status)}
    </span>
  )
}
